export class FileUpload {
  public type?: string;
  public value?: string;
  public name?: string;
}
